import React from 'react';
import PropTypes from 'prop-types';

import { ButtonDetails, Container } from './style';

const Details = ({ onDetailsClick, original }) => (
  <Container>
    <ButtonDetails data-testid="button-user-details" onClick={() => onDetailsClick(original)} variant="outlined">
      DETAILS
    </ButtonDetails>
  </Container>
);

Details.propTypes = {
  onDetailsClick: PropTypes.func,
  original      : PropTypes.shape({}),
};

Details.defaultProps = {
  onDetailsClick() {},
  original: {},
};

export default Details;
